import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Create a function that returns a TranslateHttpLoader instance
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}